import Emitter from "./Emitter";

export default class GameSpinStart extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ event: 'gameStarted' });
    }

    IGT_handler() {
        this.emitParent({ event: 'gameStarted' });
    }

    SPINGAMES_handler(data) {
        if (data && typeof data !== "object") {
            this.emitTop({ event: "round_start", balance: data });
            this.emitParent({ event: "round_start", balance: data });
        } else {
            this.emitTop({ event: "round_start"});
            this.emitParent({ event: "round_start" });
        }
    }

    BWIN_handler() {
        this.emitParent("round_start")
        this.emitTop("round_start")
    }

    GAMEIOM_handler() {
        this.emitParent(JSON.stringify({ idle: false }));
        this.emitTop("GAMEROUND_STARTED");
    }

    MGS_handler() {
        this.emitParent('{"Name" : "busy", "Origin" : "embeddedgame"}');
    }

    PLAYTECH_handler() {
        if (this.gb.gameProviderCode !== 'GAM' && this.gb.ptResFeat && this.gb.ptResFeat.includes('gameround')) {
            // this.gb.playtechPause = false;
            let data = {_type: "ucip.gameround.g2wGameRoundStartNotification"}
            if (this.gb.settings.nativeMobileApp) {
                data.handled = true;
                window.parent.postMessage(JSON.stringify(data));
        
            } else {
                this.emitParent(JSON.stringify(data));
            }
        }
    }

    POKERSTARS_handler() {
        const dataForXc = {
            "msgId":"rg2xcGameStatusUpdated",
            "status": "handStart",
        }

        if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
            window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
        } else {
            window.parent.postMessage(JSON.stringify(dataForXc), "*");
        }
    }

    LNWOGS_handler(data) {
        this.gb.wallet.gameSpinStarted();
    }

    SOFTSWISS_handler() {
        this.emitParent({type: "a8r:v1:gtp:game_animation_started"});

        // Additionally SOFTSWISS wants to receive wonAmountChange event with amount 0 to reset last round's win.
        this.gb.emitters.emit.web.wonAmountChange({payload: { winAmount: 0}});
    }

    _default(msg) {
        const data = msg ? { wpgaction: "gameSpinStart", data: msg } : { wpgaction: "gameSpinStart" };
        const dataParent = msg ? { wpgaction: "gameSpinStart.parent", data: msg } : { wpgaction: "gameSpinStart.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
